<template>
  <div ref="container" style="height:100%;width:100%;overflow:hidden">

  </div>
</template>
<script>
  export default {
    name: 'mw-html-editor',
    props: {
      value: {
        type: String,
        default: ''
      },
      params:{
        type:Object,
        default:{}
      },
      toolbarType:String
    },
    data(){
      return {
        valueChange:false,
        editorChange:false,
        editor:undefined
      }
    },
    mounted() {
      let me=this;
      //let val=me.value?PF.decode(me.value):'';
      $WR.ready(function (manager) {
        manager.create({
          xtype: 'UEditorComp',
          isFormField: false,
          toolbarType:me.toolbarType
        }, function(editor) {
          let pageData=editor.getPageData();
          pageData.params=me.params;
          let component=PF.createVue(pageData);
          $(me.$el).append(component.$mount().$el);
          me.editor = editor;
        })
      });
    },
    watch: {
      value(newVal) {
        let me=this;
        me.value=newVal;
        if(me.editor && !me.editorChange){
          me.valueChange=true;
          me.editor.setValue((me.value?me.value:''), false)
        }
        me.valueChange=false;
        me.editorChange=false;
      }
    },
    methods: {
      getValue() {
        return this.editor.getValue()
      },
      setValue(val){
        let me=this;
        me.editor.setValue((val==undefined?'':val), false)
      },
      setHeight(val){
        let me=this;
        me.editor.setHeight(val==undefined?'':val);
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/common/components/extend/html-editor/index.vue